import React, { useCallback, useState } from "react";

import Button from "@imminently/decisively-ui/Button";
import DevPanel from "@imminently/decisively-ui/DevPanel";
import TextInput from "@imminently/decisively-ui/TextInput";
import { useNotification } from "@/common/notifications";

import { downloadUnitTest } from "../utils/generateUnitTest";

export interface SessionModalDevPanelProps {
  session: any;
  release: any;
}

const SessionModalDevPanel = ({ session, release }: SessionModalDevPanelProps) => {
  const notify = useNotification();
  const [testName, setTestName] = useState(() => {
    return `session_${session?.id?.substring(0, 8) || "test"}`;
  });

  const handleDownloadUnitTest = useCallback(() => {
    try {
      downloadUnitTest(session, release, testName);
      notify.success("Unit test downloaded successfully");
    } catch (error) {
      console.error("Failed to download unit test:", error);
      notify.error(error instanceof Error ? error.message : "Failed to download unit test");
    }
  }, [session, release, testName, notify]);

  const handleDownloadReleaseJson = useCallback(() => {
    try {
      const releaseData = JSON.stringify(release, null, 2);
      const blob = new Blob([releaseData], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${testName}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      notify.success("Release JSON downloaded successfully");
    } catch (error) {
      console.error("Failed to download release JSON:", error);
      notify.error("Failed to download release JSON");
    }
  }, [release, testName, notify]);

  return (
    <DevPanel>
      <TextInput
        value={testName}
        onValueChange={(value) => setTestName(value)}
        placeholder="Test name"
        aria-label="Test name"
        fullWidth
      />
      <Button
        onClick={handleDownloadUnitTest}
        label="Download Unit Test"
      >
        Download Unit Test
      </Button>
      <Button
        variant="contained"
        intent="secondary"
        onClick={handleDownloadReleaseJson}
        label="Download Release JSON"
      >
        Download Release JSON
      </Button>
    </DevPanel>
  );
};

export default SessionModalDevPanel;
